import { CountryEnv, LANGUAGE } from "@type/index";

const _countryEnv: CountryEnv = {
  clientId: process.env.REACT_APP_CLIENT_ID_IT_UQ || "uq.it.styling-book",
  sbRootId: process.env.REACT_APP_FILTERS_SB_ROOT_ID_IT_UQ || 24187,
  shRootId: process.env.REACT_APP_FILTERS_SH_ROOT_ID_IT_UQ || 24188,
  firebaseApiKey:
    process.env.REACT_APP_FIREBASE_API_KEY_EU_UQ ||
    "AIzaSyDE056gop2EPT3-XkaMwgmebYyxvrAtm5w",
  firebaseProjectId:
    process.env.REACT_APP_FIREBASE_PROJECT_ID_EU_UQ || "fr-stg-ec-frontend",
  firebaseAppId:
    process.env.REACT_APP_FIREBASE_APP_ID_IT_UQ ||
    "1:160978693362:web:1239f2038dd56e6647346b",
  firebaseMeasurementId:
    process.env.REACT_APP_ENV === "staging" ? "G-BJX7M0ZBDM" : "",
  storeDomain: process.env.REACT_APP_STORE_DOMAIN_UQ || "",
  showAboutApp: true,
  showDualPrice: true,
  languages: [LANGUAGE.IT, LANGUAGE.EN]
};

export default _countryEnv;
